import React, { useState } from 'react';
import './ConferenceParticipant.css';
import { useTranslation } from 'react-i18next';

export default function ConferenceParticipant({ joinedParticipants }) {
    const [searchTerm, setSearchTerm] = useState("");
    const {t} = useTranslation();



    const getAvatarStyle = (role) => {
        if (role === "principal-master") return { backgroundColor: "#7C3BED", color: "white" };
        if (role === "master") return { backgroundColor: "#2662D9", color: "white" };
        return { backgroundColor: "#E3E8EF", color: "#4A5568" };
    };

    const getBadgeClass = (role) => {
        if (role === "principal-master") return "badge-purple";
        if (role === "master") return "badge-blue";
        if (role === "guest_externe") return "badge-yellow";
        if (role === "guest") return "badge-gray"
        return "badge-default";
    };

    const getDeviceConfig = (type, participant) => {
        const icons = {
            microphone: { active: 'mic', inactive: 'mic_off', 'no-access': 'mic_off' },
            camera: { active: 'videocam', inactive: 'videocam_off', 'no-access': 'videocam_off' },
            screen_share: { active: 'screen_share', inactive: 'stop_screen_share', 'no-access': 'stop_screen_share' }
        };

        const access = participant.accesses?.[0] || {};

        let hasAccess = false;
        let isActive = false;

        if (type === 'microphone') {
            hasAccess = access.allow_mic;
            isActive = participant.mic_state === 1;
        } else if (type === 'camera') {
            hasAccess = access.allow_camera;
            isActive = participant.camera_state === 1;
        } else if (type === 'screen_share') {
            hasAccess = access.allow_screen_share;
            isActive = participant.screenshare_state === 1;
        }


        let status = 'inactive';
        if (!hasAccess) {
            status = 'no-access';
        } else if (isActive) {
            status = 'active';
        }

        let colorClass = 'icon-gray';
        if (status === 'active') colorClass = 'icon-green';
        if (status === 'inactive') colorClass = 'icon-red';

        return {
            icon: icons[type][status],
            className: `material-symbols-outlined icon-device ${colorClass}`
        };
    };

    const filteredParticipants = joinedParticipants.filter(p => {
        const searchableName = p?.display_name || p.email || "";
        const matchesSearch = searchableName.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesSearch;
    });

    return (
        <div className="paricipant-container">
            <div className="search-container">
                <input
                    type="text"
                    placeholder={t('search_participant')}
                    className="search-input-conference"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
            </div>

            <div className="participants-container">
                {filteredParticipants.map((participant, index) => (
                    <div key={index} className="participant-card">
                        <div className="avatar-participant" style={getAvatarStyle(participant?.role)}>
                            {participant?.initials}
                        </div>

                        <div className="info-container">
                            <div className="name-row">
                                <span className="name-participant" title={participant.display_name}>
                                    {participant?.display_name ||
                                        (participant?.firstName ? `${participant?.firstName} ${participant?.lastName}` : t('anonymous_participant'))}

                                </span>
                                {participant?.isHandRaised && (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_59525_44381)">
                                            <path d="M11.9997 7.33301V3.99967C11.9997 3.64605 11.8593 3.30691 11.6092 3.05687C11.3592 2.80682 11.02 2.66634 10.6664 2.66634C10.3128 2.66634 9.97365 2.80682 9.7236 3.05687C9.47355 3.30691 9.33308 3.64605 9.33308 3.99967M9.33308 6.66634V2.66634C9.33308 2.31272 9.1926 1.97358 8.94255 1.72353C8.6925 1.47348 8.35336 1.33301 7.99974 1.33301C7.64612 1.33301 7.30698 1.47348 7.05693 1.72353C6.80689 1.97358 6.66641 2.31272 6.66641 2.66634V3.99967M6.66641 3.99967V6.99967M6.66641 3.99967C6.66641 3.64605 6.52593 3.30691 6.27588 3.05687C6.02584 2.80682 5.6867 2.66634 5.33308 2.66634C4.97945 2.66634 4.64032 2.80682 4.39027 3.05687C4.14022 3.30691 3.99974 3.64605 3.99974 3.99967V9.33301M11.9997 5.33301C11.9997 4.97939 12.1402 4.64025 12.3903 4.3902C12.6403 4.14015 12.9795 3.99967 13.3331 3.99967C13.6867 3.99967 14.0258 4.14015 14.2759 4.3902C14.5259 4.64025 14.6664 4.97939 14.6664 5.33301V9.33301C14.6664 10.7475 14.1045 12.104 13.1043 13.1042C12.1041 14.1044 10.7476 14.6663 9.33308 14.6663H7.99974C6.13308 14.6663 4.99974 14.093 4.00641 13.1063L1.60641 10.7063C1.37703 10.4523 1.25413 10.1198 1.26316 9.77763C1.27218 9.43548 1.41244 9.10991 1.65489 8.86831C1.89734 8.62672 2.22341 8.48762 2.56559 8.47981C2.90777 8.47199 3.23985 8.59607 3.49308 8.82634L4.66641 9.99967" stroke="#E79E04" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_59525_44381">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                )}
                            </div>

                            {(participant?.role) && (
                                <>
                                    <div className={`badge ${getBadgeClass(participant?.role)}`}>
                                        {participant?.role === "principal-master" && participant.mic_state === 0 && (
                                            <svg className="crown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7z"></path>
                                            </svg>
                                        )}
                                        {participant?.role === "master" && participant.mic_state === 0 && (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M13.3336 8.66664C13.3336 12 11.0003 13.6666 8.22699 14.6333C8.08176 14.6825 7.92401 14.6802 7.78032 14.6266C5.00032 13.6666 2.66699 12 2.66699 8.66664V3.99997C2.66699 3.82316 2.73723 3.65359 2.86225 3.52857C2.98728 3.40355 3.15685 3.33331 3.33366 3.33331C4.66699 3.33331 6.33366 2.53331 7.49365 1.51997C7.63489 1.39931 7.81456 1.33301 8.00032 1.33301C8.18608 1.33301 8.36575 1.39931 8.50699 1.51997C9.67365 2.53997 11.3337 3.33331 12.667 3.33331C12.8438 3.33331 13.0134 3.40355 13.1384 3.52857C13.2634 3.65359 13.3336 3.82316 13.3336 3.99997V8.66664Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        )}
                                        {participant?.role === "guest_externe" && participant.mic_state === 0 && (
                                            <span className="material-symbols-outlined">
                                                language
                                            </span>
                                        )}
                                        {participant?.role === "guest" && participant.mic_state === 0 && (
                                            <span className="material-symbols-outlined">
                                                hotel_class
                                            </span>
                                        )}

                                        {participant?.mic_state === 0 &&
                                            t(`${participant?.role}`)
                                        }
                                    </div>

                                    {participant?.mic_state === 1 && (
                                        <div className="badge badge-green">
                                            <span className="material-symbols-outlined">volume_up</span>
                                            <span>{t('has_speech')}</span>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        <div className="actions">
                            {['microphone', 'camera', 'screen_share'].map((deviceType) => {
                                const config = getDeviceConfig(deviceType, participant);
                                return (
                                    <span key={deviceType} className={config.className}>
                                        {config.icon}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}